// extracted by mini-css-extract-plugin
module.exports = {"content":"e2ff468f85--content--CUcnq","footer":"e2ff468f85--footer--JnB5U","row":"e2ff468f85--row--FtvVn","row-label":"e2ff468f85--row-label--KUXqL"};